import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeliveryService } from 'src/app/services/delivery.service';
import { Delivery } from 'src/app/models/delivery.schema';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-unlock-pickup',
  templateUrl: './unlock-pickup.component.html',
  styleUrls: ['./unlock-pickup.component.scss']
})
export class UnlockPickupComponent implements OnInit {

  valetCode = '';
  showError = false;
  loading = false;
  delivery: Delivery;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { delivery: Delivery },
    public dialogRef: MatDialogRef<UnlockPickupComponent>,
    private commanUsesService: CommanUsesService,
    private deliveryService: DeliveryService,
    private spinnerService: SpinnerService,
  ) { }

  async ngOnInit() {
    try {
      this.delivery = this.data.delivery;
    } catch (error) {
      const errorMsg: string = error?.error?.message || error?.message;
      this.commanUsesService.showSnackBar(errorMsg);
    }
  }

  get isValid(): boolean {
    return !!this.valetCode && this.valetCode.length >= 1;
  }

  onInput(e: Event) {
    const target = e.target as HTMLInputElement;
    let value = target.value.replace(/[^0-9]/g, '');
    this.valetCode = value;
    this.showError = !/^\d{1,8}$/.test(value); 
    if (value.length > 8) {
      this.valetCode = value.slice(0, 8); 
    }
  }

  async submitCode() {
    if (!this.isValid || this.loading) return;
    this.loading = true;
    try {
      const promiseResult = await this.deliveryService.unlockPickUp(this.delivery.id, this.valetCode);
      if(promiseResult.id && promiseResult.expertVerified) {
        this.dialogRef.close({ delivery: this.delivery });
      } else {
        this.commanUsesService.showSnackBar("SOMETHING_WENT_WRONG");
      }
    } catch (error) {
      const errorMsg: string = error?.error?.message || error?.message;
      this.commanUsesService.showSnackBar(errorMsg);
    } finally {
      this.loading = false;
    }
  }

}
